// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("DirectMessage", {
  id: __t.u64(),
  conversationId: __t.u64(),
  fromUserId: __t.u64(),
  toUserId: __t.u64(),
  message: __t.string(),
  createdAt: __t.u64(),
  readAt: __t.option(__t.u64()),
});


